import {observer} from "mobx-react-lite";

import './CreatePage/styles.css';

import { NFTStorage } from 'nft.storage';
import { PinataSDK } from "pinata-web3";

import {ReactComponent as UploadIcon} from '../assets/icons/upload.svg';
import {ReactComponent as CloseIcon} from '../assets/icons/removeFile.svg';
import React, {ChangeEvent, useEffect, useState} from "react";

import MarketItem from './MarketItem';
import CardStore, { NftType } from "src/stores/CardStore";
import { useStores } from "src/stores/useStores";
import { NODE_URL_MAP, PINATA_JWT } from "src/constants";
import { waitForTx } from "@waves/waves-transactions";
import Switch from "./Switch";

interface ICreatePageProps {

}

interface ISourceInfo {
    file: File,
    size: string;
    url: string;
}

const MAINNET_CREATE_DAPP = '3PFQjjDMiZKQZdu5JqTHD7HwgSXyp9Rw9By';
const MAINNET_ADDRESS = NODE_URL_MAP.W;

// const STORAGE_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDEyODlFRDlGNDg0RGJFOTAyNDcxMzZFQTVEM2QwOURlM0MxRDY1NDkiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY2MDc0NjM2MTY1MywibmFtZSI6InB1enpsZW1hcmtldCJ9.KIlKKcRcbo0hcdoVfFLi4Gqww0oYaDj9_SGM_EzBvlQ';

const nftStorageClient = new NFTStorage({ token: '3e4617b8.6ec9a5992f57448ca37f8e7bb3311716' });

const LIMIT_MINT_COPIES = 10000;

export default observer(function(props: ICreatePageProps) {
    const { accountStore, notificationStore } = useStores();

    const [creating, setCreating] = useState<boolean>(false);

    const [originalFileValue, setOriginalFileValue] = useState<string>();
    const [previewFileValue, setPreviewFileValue] = useState<string>();

    const [original, setOriginal] = useState<File|null>();
    const [preview, setPreview] = useState<File|null>();

    const [name, setName] = useState<string>();
    const [collection, setCollection] = useState<string>();
    const [description, setDescription] = useState<string>();
    const [amountCopies, setAmountCopies] = useState<number>(2);

    const [sourceOriginalMsg, setSourceOriginalMsg] = useState<string>();
    const [sourcePreviewMsg, setSourcePreviewMsg] = useState<string>();
    const [nameMsg, setNameMsg] = useState<string>();
    const [collectionMsg, setCollectionMsg] = useState<string>();
    const [amountCopiesMsg, setAmountCopiesMsg] = useState<string>();
    const [variousMsg, setVariousMsg] = useState<string>();
    const [variousSizeMsg, setVariousSizeMsg] = useState<string>();

    const [sourceOriginalInfo, setSourceOriginalInfo] = useState<ISourceInfo|null>();
    const [sourcePreviewInfo, setSourcePreviewInfo] = useState<ISourceInfo|null>();

    const [isMultiple, setIsMultiple] = useState<boolean>(false);
    const [isVarious, setIsVarious] = useState<boolean>(false);
    const [withParams, setWithParams] = useState<boolean>(false);

    const [collectionFiles, setCollectionFiles] = useState<{file: File, count: number, params?: string}[]>([]);

    const onChangeOriginalFile = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target?.files?.[0]) {
            const file = e.target.files[0];
            setOriginal(file);

            if (isAllowFileType(file)) {
                setSourceOriginalInfo({
                    file,
                    size: (file.size / 1024 / 1024).toFixed(2) + ' MB',
                    url: URL.createObjectURL(file)
                });
            }
        }
        if (e.target.value) {
            setOriginalFileValue(e.target.value);
        }
    }

    const onChangePreviewFile = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target?.files?.[0]) {
            const file = e.target.files[0];
            setPreview(file);

            if (isAllowFileType(file)) {
                setSourcePreviewInfo({
                    file,
                    size: (file.size / 1024 / 1024).toFixed(2) + ' MB',
                    url: URL.createObjectURL(file)
                });
            }
        }
        if (e.target.value) {
            setPreviewFileValue(e.target.value);
        }
    }

    const onChangeCollectionFiles = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files?.length) {
            const newCollectionFiles = [...(collectionFiles || [])];
            for (let i = 0; i < e.target.files.length; i++) {
                newCollectionFiles.push({file: e.target.files[i], count: 0, params: ''});
            }
            setCollectionFiles([...newCollectionFiles]);
        }
    }

    const onChangeMultiple = (newValue: boolean) => {
        if (!newValue) {
            onChangeVarious(newValue);
        }
        setIsMultiple(newValue);
    }

    const onChangeVarious = (newValue: boolean) => {
        if (!newValue && collectionFiles.length) {
            setCollectionFiles([]);
        }
        setIsVarious(newValue);
    }

    const onWithParams = (newValue: boolean) => {
        if (!newValue && collectionFiles.length) {
            collectionFiles.forEach((item) => {
                item.params = '';
            })
        }
        setWithParams(newValue);
    }

    const deleteFromCollectionFiles = (index: number) => {
        collectionFiles.splice(index, 1)
        setCollectionFiles([...collectionFiles]);
    }
    const changeCountCollectionFiles = (e: ChangeEvent<HTMLInputElement>, index: number) => {
        collectionFiles[index].count = parseInt(e.target.value || '0', 10);
        setCollectionFiles([...collectionFiles]);
    }
    const changeParamsCollectionFiles = (e: ChangeEvent<HTMLTextAreaElement>, index: number) => {
        collectionFiles[index].params = e.target.value || '';
        setCollectionFiles([...collectionFiles]);
    }

    const cardItem = new CardStore({
        name: name || '',
        quantity: 1,
        assetId: '',
        type: NftType.ORIGIN,
        description: '',
        issuer: '3PFQjjDMiZKQZdu5JqTHD7HwgSXyp9Rw9By',
        creator: '',
        owner: '',
        data: collection ? `{"collection": "${accountStore.address}_${collection}", "num": 1}` : '',
        image: sourcePreviewInfo ? URL.createObjectURL(sourcePreviewInfo.file) : ''
    }, accountStore.rootStore);

    const isAllowFileType = (file: File) => {
        return ['image/jpeg', 'image/png', 'image/gif', 'video/mp4', 'audio/mpeg', 'audio/mp3'].indexOf(file.type) >= 0;
    }

    const isVideo = (file: File) => {
        return ['video/mp4'].indexOf(file.type) >= 0;
    }

    const onDeleteOriginalFile = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        e.preventDefault();
        setOriginal(null);
        setOriginalFileValue('');
        setSourceOriginalInfo(null);
    }

    const onDeletePreviewFile = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        e.preventDefault();
        setPreview(null);
        setPreviewFileValue('');
        setSourcePreviewInfo(null);
    }

    const onCreateNft = async () => {
        if (validate() && sourceOriginalInfo && original && sourcePreviewInfo && preview && name && collection) {
            const origFileExtension = original.name.split('.').pop();
            const previewFileExtension = preview.name.split('.').pop();

            const sourceUrl = 'https://ipfs.io/ipfs/';
            let previewName = 'display.' + previewFileExtension?.toLowerCase();
            let originalName = 'original.' + origFileExtension?.toLowerCase();

            try {
                setCreating(true);

                const pinata = new PinataSDK({
                    pinataJwt: PINATA_JWT,
                    pinataGateway: "magenta-official-dragon-804.mypinata.cloud",
                });

                const uploadedFiles = await pinata.upload.fileArray([
                    new File([original], originalName, {type: original.type}),
                    new File([preview], previewName, {type: preview.type})
                ]);

                if (!uploadedFiles?.IpfsHash) {
                    throw new Error('Invalid CID address');
                }

                const originalUrl = sourceUrl + uploadedFiles.IpfsHash +'/' + originalName;
                const previewUrl = sourceUrl + uploadedFiles.IpfsHash +'/' + previewName;

                const params: any = {
                    name: name.trim(),
                    desc: (description || '').trim(),
                    collection: collection.trim(),
                    original: originalUrl,
                    preview: previewUrl,
                    amount: 1,
                    sourceList: "",
                    randIndexList: "",
                    paramsList: ""
                };

                if (isMultiple) {
                    if (!amountCopies || amountCopies < 2 || amountCopies > LIMIT_MINT_COPIES) {
                        throw new Error("Wrong amount copies");
                    }

                    params.amount = amountCopies;

                    if (isVarious) {
                        const randIndexList: number[] = [];
                        const sourceList: string[] = [];
                        const paramsList: string[] = [];
                        const files = collectionFiles.map((item, index) => {
                            const fileName = `display${index}.` + item.file.name.split('.').pop()?.toLowerCase();

                            for (let i = 0; i < item.count; i++) {
                                randIndexList.push(index);
                            }
                            sourceList.push(fileName);
                            paramsList.push(item.params || '');

                            return new File([item.file], fileName, {type: item.file.type});
                        });

                        if (!randIndexList.length) {
                            throw new Error("Rand index empty");
                        }
                        if (!sourceList.length) {
                            throw new Error("Source list empty");
                        }
                        if (!paramsList.length) {
                            throw new Error("Params list empty");
                        }
                        if (!files.length) {
                            throw new Error("Files list empty");
                        }
                        if (randIndexList.length !== amountCopies) {
                            throw new Error("Rand list length not equal to amount copies");
                        }

                        const cidFiles = await nftStorageClient.storeDirectory(files);
                        sourceList.forEach((fileName, index) => {
                            sourceList[index] = sourceUrl + cidFiles +'/' + fileName;
                        });

                        params.sourceList = sourceList.join(",");
                        params.randIndexList = randIndexList.join(",");
                        params.paramsList = paramsList.join(",");
                    }
                }

                const txId = await accountStore.invoke({
                    dApp: MAINNET_CREATE_DAPP,
                    payment: [{assetId: null, amount: 5000000}],
                    call: {
                        function: 'mint',
                        args: [
                            {type: 'string', value: params.name},
                            {type: 'string', value: params.desc},
                            {type: 'string', value: params.collection},
                            {type: 'string', value: params.preview},
                            {type: 'string', value: params.original},
                            {type: 'integer', value: params.amount},
                            {type: 'string', value: params.sourceList},
                            {type: 'string', value: params.randIndexList},
                            {type: 'string', value: params.paramsList},
                        ]
                    }
                });
                await waitForTx(txId as string, { apiBase: MAINNET_ADDRESS });
                if (txId) {
                    notificationStore.notify(`Your NFT minted`, {
                        type: "success",
                        title: `Success`,
                        link: `/wallet`,
                        linkTitle: "View on Wallet",
                    });

                    //clear info
                    setOriginal(null);
                    setSourceOriginalInfo(null);
                    setOriginalFileValue('');

                    setPreview(null);
                    setSourcePreviewInfo(null);
                    setPreviewFileValue('');

                    setName('');
                    setCollection('');
                    setDescription('');

                    setAmountCopies(2);
                    setCollectionFiles([]);
                }
            } catch(e: any) {
                console.error(e);
                notificationStore.notify(e.message ?? JSON.stringify(e), {
                    type: 'error',
                    title: 'Transaction is not completed'
                });
            } finally {
                setCreating(false);
            }
        }
    }

    const validate = (types?: string[]) => {
        let result = true;

        // validate original
        if (!types?.length || types.indexOf('original') >= 0) {
            if (!original) {
                setSourceOriginalMsg('Upload the file to mint it');
                result = result && false;
            } else if(!isAllowFileType(original)) {
                setSourceOriginalMsg('Invalid content type, valid: PNG, GIF, WEBP, JPEG, MP4');
                result = result && false;
            } else if(original.size > 1024 * 1024 * 10) {
                setSourceOriginalMsg('The maximum file size should be 10 MB');
                result = result && false;
            } else {
                setSourceOriginalMsg('');
            }
        }

        // validate preview
        if (!types?.length || types.indexOf('preview') >= 0) {
            if (!preview) {
                setSourcePreviewMsg('Upload the file to mint it');
                result = result && false;
            } else if(!isAllowFileType(preview)) {
                setSourcePreviewMsg('Invalid content type, valid: PNG, GIF, WEBP, JPEG, MP4');
                result = result && false;
            } else if(preview.size > 1024 * 1024 * 2) {
                setSourcePreviewMsg('The maximum file size should be 2 MB');
                result = result && false;
            } else {
                setSourcePreviewMsg('');
            }
        }

        // validate name
        if (!types?.length || types.indexOf('name') >= 0) {
            if (!name) {
                setNameMsg('Write the item name');
                result = result && false;
            } else {
                setNameMsg('');
            }
        }

        // validate collection
        if (!types?.length || types.indexOf('collection') >= 0) {
            if (!collection) {
                setCollectionMsg('Write the collection name');
                result = result && false;
            } else {
                setCollectionMsg('');
            }
        }

        // validate number of copies
        if (isMultiple && (!types?.length || types.indexOf('amountCopies') >= 0)) {
            if (amountCopies < 2 || amountCopies > LIMIT_MINT_COPIES) {
                setAmountCopiesMsg(`Range within: 2-${LIMIT_MINT_COPIES}`);
                result = result && false;
            } else {
                setAmountCopiesMsg('');
            }
        }

        if (isVarious) {
            const amountFileCopies = collectionFiles.reduce((prev, cur) => prev + cur.count, 0);
            if (amountCopies !== amountFileCopies) {
                result = result && false;
                setVariousMsg('The number of copies must match the sum of the number of copies of each file. ' + `Max: ${amountCopies}`);
            } else if (amountCopies === amountFileCopies && amountCopies < collectionFiles.length) {
                result = result && false;
                setVariousMsg('The number of copies must be less than or equal to the number of downloaded files. ' + `Max: ${amountCopies}`);
            } else  {
                setVariousMsg('');
            }

            const isOutOfSize = collectionFiles.some(item => item.file.size > 1024 * 1024 * 2);
            if (isOutOfSize) {
                result = result && false;
                setVariousSizeMsg('File size must not exceed 2 MB');
            } else  {
                setVariousSizeMsg('');
            }
        }

        return result;
    }

    return (
        <div className="nftMarketplace-createPage__content">
            <h1 className="nftMarketplace-createPage__title">Create a new item</h1>
            <div className="nftMarketplace-createPage__wrap">
                <div className="nftMarketplace-createPage__body">
                    <div className="nftMarketplace-createPage__block">
                        <div className="nftMarketplace-createPage__blockTitle">Upload preview file</div>
                        <div className="nftMarketplace-createPage__blockDesc">Will be displayed on the NFT card</div>
                        <div className="nftMarketplace-createPage__blockContent">
                            <label
                                htmlFor="preview-file-upload"
                                className={'nftMarketplace-createPage__uploadFileBlock' + (sourcePreviewMsg ? ' nftMarketplace-createPage__uploadFileBlock_error' : '')}>
                                <input id="preview-file-upload" type="file" onChange={onChangePreviewFile} value={previewFileValue} accept="image/*,video/mp4,audio/mpeg"/>
                                <div>
                                    <UploadIcon />
                                </div>
                                <div className="nftMarketplace-createPage__uploadFile">
                                    { preview ? preview.name : 'PNG, GIF, WEBP, JPEG, MP4, MP3 max 2 Mb' }&nbsp;
                                    { preview ? <CloseIcon onClick={onDeletePreviewFile}/> : '' }
                                </div>
                            </label>
                            {
                                sourcePreviewInfo ? <div className="nftMarketplace-createPage__inputHint">
                                    <div>
                                        <a href={sourcePreviewInfo.url} target="_blank">Original file ({sourcePreviewInfo.size})</a>&nbsp;
                                        - Will be available for download
                                    </div>
                                </div> : ''
                            }
                            {
                                sourcePreviewMsg ? <div className="nftMarketplace-createPage__inputHint nftMarketplace-createPage__inputHint_error">{sourcePreviewMsg}</div> : ''
                            }
                        </div>
                    </div>

                    <div className="nftMarketplace-createPage__block">
                        <div className="nftMarketplace-createPage__blockTitle">Upload original file</div>
                        <div className="nftMarketplace-createPage__blockDesc">Will be available for download</div>
                        <div className="nftMarketplace-createPage__blockContent">
                            <label
                                htmlFor="orgiginal-file-upload"
                                className={'nftMarketplace-createPage__uploadFileBlock' + (sourceOriginalMsg ? ' nftMarketplace-createPage__uploadFileBlock_error' : '')}>
                                <input id="orgiginal-file-upload" type="file" onChange={onChangeOriginalFile} value={originalFileValue} accept="image/*,video/mp4,audio/mpeg"/>
                                <div>
                                    <UploadIcon />
                                </div>
                                <div className="nftMarketplace-createPage__uploadFile">
                                    { original ? original.name : 'PNG, GIF, WEBP, JPEG, MP4, MP3 max 10 Mb' }&nbsp;
                                    { original ? <CloseIcon onClick={onDeleteOriginalFile}/> : '' }
                                </div>
                            </label>
                            {
                                sourceOriginalInfo ? <div className="nftMarketplace-createPage__inputHint">
                                    <div>
                                        <a href={sourceOriginalInfo.url} target="_blank">Original file ({sourceOriginalInfo.size})</a>&nbsp;
                                        - Will be available for download
                                    </div>
                                </div> : ''
                            }
                            {
                                sourceOriginalMsg ? <div className="nftMarketplace-createPage__inputHint nftMarketplace-createPage__inputHint_error">{sourceOriginalMsg}</div> : ''
                            }
                        </div>
                    </div>

                    <div className="nftMarketplace-createPage__block">
                        <div className="nftMarketplace-createPage__blockTitle">
                            <div>Item details</div>

                            <div className="nftMarketplace-createPage__switchBlock">
                            {
                                isMultiple ? 
                                    <div className="nftMarketplace-createPage__switch">
                                        <label>Various</label>&nbsp;
                                        <Switch
                                            onChange={() => onChangeVarious(!isVarious)}
                                            value={isVarious}
                                        />
                                    </div> : ''
                            }
                                <div className="nftMarketplace-createPage__switch">
                                    <label>Multiple</label>&nbsp;
                                    <Switch
                                        onChange={() => onChangeMultiple(!isMultiple)}
                                        value={isMultiple}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="nftMarketplace-createPage__blockContent">
                            <div className={'nftMarketplace-createPage__inputBlock' + (nameMsg ? ' nftMarketplace-createPage__inputBlock_error' : '')}>
                                <div className="nftMarketplace-createPage__inputLabel">Item name</div>
                                <input
                                    className={'nftMarketplace-createPage__input' + (nameMsg ? ' nftMarketplace-createPage__input_error' : '')}
                                    type="text"
                                    value={name}
                                    maxLength={16}
                                    onChange={(e) => {setName(e.target.value.replace(/[^a-zA-Z0-9-#№ ]/g, ""))}}/>
                                <div className="nftMarketplace-createPage__inputHint">Max 16 symbols. {name?.length} Left.</div>
                                {
                                    nameMsg ? <div className="nftMarketplace-createPage__inputHint nftMarketplace-createPage__inputHint_error">{nameMsg}</div> : ''
                                }
                            </div>

                            <div className="nftMarketplace-createPage__inputBlock">
                                <div className="nftMarketplace-createPage__inputLabel">Description (Optional)</div>
                                <textarea
                                    className="nftMarketplace-createPage__input"
                                    value={description}
                                    maxLength={1000}
                                    onChange={(e) => {setDescription(e.target.value.replace(/[\|]/g, ""))}}></textarea>
                                <div className="nftMarketplace-createPage__inputHint">Max 1000 symbols. {description?.length} Left.</div>
                            </div>

                            <div className={'nftMarketplace-createPage__groupBlock' + (isMultiple ? ' nftMarketplace-createPage__groupBlock_2col' : '')}>
                                <div className={'nftMarketplace-createPage__inputBlock' + (collectionMsg ? ' nftMarketplace-createPage__inputBlock_error' : '')}>
                                    <div className="nftMarketplace-createPage__inputLabel">Collection name</div>
                                    <input
                                        className={'nftMarketplace-createPage__input' + (collectionMsg ? ' nftMarketplace-createPage__input_error' : '')}
                                        type="text"
                                        value={collection}
                                        maxLength={60}
                                        onChange={(e) => {setCollection(e.target.value.replace(/[^a-zA-Z0-9- ]/g, ""))}}/>
                                    <div className="nftMarketplace-createPage__inputHint">Max 60 symbols. {collection?.length} Left.</div>
                                    {
                                        collectionMsg ? <div className="nftMarketplace-createPage__inputHint nftMarketplace-createPage__inputHint_error">{collectionMsg}</div> : ''
                                    }
                                </div>

                                {
                                    isMultiple ?
                                        <div className={'nftMarketplace-createPage__inputBlock' + (amountCopiesMsg ? ' nftMarketplace-createPage__inputBlock_error' : '')}>
                                            <div className="nftMarketplace-createPage__inputLabel">Number of copies</div>
                                            <input
                                                className={'nftMarketplace-createPage__input' + (amountCopiesMsg ? ' nftMarketplace-createPage__input_error' : '')}
                                                type="number"
                                                min={2}
                                                max={LIMIT_MINT_COPIES}
                                                value={amountCopies}
                                                onChange={(e) => {setAmountCopies(parseInt(e.target.value, 10))}}/>
                                            <div className="nftMarketplace-createPage__inputHint">Min 2. Max 10 000.</div>
                                            {
                                                amountCopiesMsg ? <div className="nftMarketplace-createPage__inputHint nftMarketplace-createPage__inputHint_error">{amountCopiesMsg}</div> : ''
                                            }
                                        </div> : ''
                                }
                            </div>
                        </div>
                    </div>

                    {
                        isVarious ?
                        <div className="nftMarketplace-createPage__block">
                            <div className="nftMarketplace-createPage__blockTitle">
                                <div>Collection settings</div>
                                <div className="nftMarketplace-createPage__switchBlock">
                                    <div className="nftMarketplace-createPage__switch">
                                        <label>With params</label>&nbsp;
                                        <Switch
                                            onChange={() => onWithParams(!withParams)}
                                            value={withParams}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="nftMarketplace-createPage__blockDesc">Select files and set for each number to mint. NFT will be minted randomly.</div>
                            <div className="nftMarketplace-createPage__blockContent">
                                <label
                                    htmlFor="collectionFiles-file-upload"
                                    className={'nftMarketplace-createPage__uploadFileBlock' + (variousMsg ? ' nftMarketplace-createPage__uploadFileBlock_error' : '')}>
                                    <input id="collectionFiles-file-upload" type="file" onChange={onChangeCollectionFiles} multiple={true} accept="image/*,video/mp4,audio/mpeg"/>
                                    <div>
                                        <UploadIcon />
                                    </div>
                                    <div className="nftMarketplace-createPage__uploadFile">
                                        PNG, GIF, WEBP, JPEG, MP4, MP3 max 2 Mb
                                    </div>
                                </label>
                                <div className="nftMarketplace-createPage__filesTable">
                                    { collectionFiles.map((item, index) => {
                                        return <div key={index} className="nftMarketplace-createPage__filesTableRow">
                                            <div className="nftMarketplace-createPage__filesTableCell">
                                                <a href={URL.createObjectURL(item.file)} target="_blank">
                                                    {
                                                        isVideo(item.file) ?
                                                            <video autoPlay muted loop width="70">
                                                                <source src={URL.createObjectURL(item.file)} type={item.file.type} />
                                                            </video> :
                                                            <img width="70" src={URL.createObjectURL(item.file)} alt="" />
                                                    }
                                                    
                                                </a>
                                            </div>
                                            <div className="nftMarketplace-createPage__filesTableCell"><a href={URL.createObjectURL(item.file)} target="_blank">{item.file.name}</a></div>
                                            <div className="nftMarketplace-createPage__filesTableCell">{(item.file.size / 1024 / 1024).toFixed(2) + ' MB'}</div>
                                            <div className="nftMarketplace-createPage__filesTableCell nftMarketplace-createPage__filesTableRight">
                                                <input
                                                    className="nftMarketplace-createPage__input"
                                                    type="number"
                                                    placeholder="N of copies"
                                                    style={{width: '70px'}}
                                                    value={item.count}
                                                    min={1}
                                                    onChange={(e) => changeCountCollectionFiles(e, index)}/>&nbsp;
                                            </div>
                                            <div className="nftMarketplace-createPage__filesTableCell">
                                                <div>
                                                <span title={`Probability ${(item.count / amountCopies * 100).toFixed()} %`}>P: {(item.count / amountCopies * 100).toFixed()} %</span>
                                                <br />
                                                <span title={`Rare ${(item.count ? (1 / item.count * 100) : 0).toFixed()} %`}>R: {(item.count ? (1 / item.count * 100) : 0).toFixed()} %</span>
                                                </div>
                                            </div>
                                            <div className="nftMarketplace-createPage__filesTableCell nftMarketplace-createPage__filesTableRight">
                                                <button
                                                    className="nftMarketplace-createPage__button nftMarketplace-createPage__button_white"
                                                    style={{padding: '12px 25px'}}
                                                    onClick={() => deleteFromCollectionFiles(index)}>Delete</button>
                                            </div>
                                        </div>
                                    }) }
                                </div>
                                <div className="nftMarketplace-createPage__paramsTable">
                                    {
                                        withParams ? collectionFiles.map((item, index) => {
                                            return <div key={index} className="nftMarketplace-createPage__filesTableRow">
                                                <div className="nftMarketplace-createPage__filesTableCell">
                                                    <a href={URL.createObjectURL(item.file)} target="_blank">
                                                        {
                                                            isVideo(item.file) ?
                                                                <video autoPlay muted loop width="70">
                                                                    <source src={URL.createObjectURL(item.file)} type={item.file.type} />
                                                                </video> :
                                                                <img width="70" src={URL.createObjectURL(item.file)} alt="" />
                                                        }
                                                    </a>
                                                </div>
                                                <div className="nftMarketplace-createPage__filesTableCell">
                                                    <textarea
                                                        className="nftMarketplace-createPage__input"
                                                        value={item.params}
                                                        maxLength={50}
                                                        placeholder="Write NFT parameters here"
                                                        style={{width: '100%'}}
                                                        onChange={(e) => {changeParamsCollectionFiles(e, index)}}></textarea>
                                                </div>
                                            </div>
                                        }) : ''
                                    }
                                </div>
                                {
                                    variousMsg ? <div className="nftMarketplace-createPage__inputHint nftMarketplace-createPage__inputHint_error">{variousMsg}</div> : ''
                                }
                                {
                                    variousSizeMsg ? <div className="nftMarketplace-createPage__inputHint nftMarketplace-createPage__inputHint_error">{variousSizeMsg}</div> : ''
                                }
                            </div>
                        </div> : ''
                    }

                    <button
                        className={'nftMarketplace-createPage__button nftMarketplace-createPage__button_w100' + (creating ? ' nftMarketplace-createPage__button_disabled' : '')}
                        onClick={onCreateNft}>Create NFT</button>
                </div>
                <div className="nftMarketplace-createPage__preview">
                    <div className="nftMarketplace-createPage__block">
                        <div className="nftMarketplace-createPage__blockTitle">Preview</div>
                        <div className="nftMarketplace-createPage__blockContent">
                            <MarketItem item={cardItem} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});